import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';
import { TNumberInputs } from '../../types/filter';
import { NumberInput } from '../NumberInput';
import * as styles from '../Filters/Filters.css';

interface IPriceInputProps {
  minPrice: TNumberInputs;
  maxPrice: TNumberInputs;
  error: boolean;
  onChange: (type: 'minPrice' | 'maxPrice') => (value: number | void) => void;
  onBlur: () => void;
}

export function PriceInput({ minPrice, maxPrice, error, onChange, onBlur }: IPriceInputProps) {
  return (
    <>
      <InlineText2>Цена</InlineText2>
      <div className={styles['input__wrapper']}>
        <NumberInput
          leftAdornment="от:"
          value={minPrice}
          onChange={onChange('minPrice')}
          onBlur={onBlur}
          min={0}
          invalid={error}
        />
        <NumberInput
          leftAdornment="до:"
          value={maxPrice}
          onChange={onChange('maxPrice')}
          onBlur={onBlur}
          min={0}
          invalid={error}
        />
      </div>
    </>
  );
}
